import React, {useContext, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import DesktopViewContext from "../context/DesktopViewContext";
import '../card.css';
import ThankYou from "./ThankYou";
const NewClientRequest = ({ }) => {
  const {desktopView} = useContext(DesktopViewContext);
  const [showThankYou, setShowThankYou] = useState(null);
  const [selectedInterest, setSelectedInterest] = useState(null);
  const navigate = useNavigate();
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  const [formData, setFormData] = useState({ name: "", email: "", tel: "" });
  const handleNameOrEmailChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const sendRequest = async () => {
    try {
      const response = await fetch(api_endpoint + "/api/request", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          interest_level: selectedInterest
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Data returned:", data);
      // Handle the response data here
    } catch (error) {
      console.error("Error inserting skill:", error);
      // Handle the error appropriately
    }
  };
  useEffect(() => {
    if (!selectedInterest) return;
    if (!formData.name || !formData.email) {
      alert("Kérjük töltse ki a mindkét mezőt!");
      return;
    }
    if (!formData.email.includes('@')) {
      alert("Érvényes email címet adjon meg!");
      return; 
    }
    sendRequest();
    setShowThankYou(true);
    setTimeout(() => {
      navigate("/");
    }, 6000);
  }, [selectedInterest]);

  if (showThankYou) {
    return (<ThankYou/>)
  }
    return (
      <>
        <div className="contact">
          <h3>Hirdessen állást nálunk!</h3>
          <li>
            {" "}
            Fedezze fel a teherautósofőrök toborzásának új dimenzióját a kamionosállások.com
            állásportálon!{" "}
          </li>
          <li>
            {" "}
            Nálunk nem kell önéletrajzokat átnéznie, hiszen hozzáférhet egy
átfogó sofőr adatbázishoz, amelyből azonnal kiválaszthatja a megfelelő jelöltet.{" "}
          </li>
          <li>
            {" "}
            Legyen szó hosszú- vagy rövidtávú megbízásról, platformunk lehetővé teszi, hogy
            gyorsan és hatékonyan találja meg az igényeinek legjobban megfelelő sofőröket.{" "}
          </li>
          <h3>Kérjen árajánlatot</h3>
          <p>
            {" "}
            Töltse ki az alábbi űrlapot, válassza ki melyik hirdetési csomag érdekli (nem végleges a választott csomag), majd csapatunk hamarosan felveszi önnel a
            kapcsolatot.{" "}
          </p>
          <input
            className="input-field"
            type="name"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleNameOrEmailChange}
            required
            autoFocus
            placeholder="Írja be a saját vagy cége nevét"
          />
          <input
            className={`input-field`}
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleNameOrEmailChange}
            required
            placeholder="Írja be az e-mail címét"
          />
          <input
            className={`input-field`}
            type="tel"
            id="tel"
            name="tel"
            value={formData.tel}
            onChange={handleNameOrEmailChange}
            required
            placeholder="Írja be a telefonszámát"
          />
          <br></br>
          <br></br>
          <br></br>
          <div className="box-container">
	<div className="box-item">
    <div className="flip-box" style={{    minWidth: !desktopView ? "70vw" : "15vw"}}>
      <div className="flip-box-front text-center" >
        <div className="inner color-white">
          <h3 className="flip-box-header">1 Hónapos Hirdetés</h3>
          <img src="https://s25.postimg.cc/65hsttv9b/cta-arrow.png" alt="" className="flip-box-img"/>
        </div>
      </div>
      <div className="flip-box-back text-center" >
        <div className="inner color-white">
          <p>Ideális választás azoknak, akik gyorsan keresnek egy-kát állásra sofőrt.</p>
          <button onClick={() => { setSelectedInterest(1); }} className="flip-box-button">Ez érdekel</button>
        </div>
      </div>
    </div>
	</div>
	<div className="box-item">
    <div className="flip-box" style={{    minWidth: !desktopView ? "70vw" : "15vw"}}>
      <div className="flip-box-front text-center" >
        <div className="inner color-white">
          <h3 className="flip-box-header">3 Hónapos Hirdetés</h3>

          <img src="https://s25.postimg.cc/65hsttv9b/cta-arrow.png" alt="" className="flip-box-img"/>
        </div>
      </div>
      <div className="flip-box-back text-center" >
        <div className="inner color-white">
        <p>Tökéletes hosszabb távú hirdetési lehetőség, amely
        biztosítja, hogy hirdetései továbbra is láthatóak legyenek, így biztosan talál sofőrt.</p>
          <button onClick={() => { setSelectedInterest(2); }} className="flip-box-button">Ez érdekel</button>
        </div>
      </div>
    </div>
	</div>
	<div className="box-item">
    <div className="flip-box" style={{    minWidth: !desktopView ? "70vw" : "15vw" }}>
      <div className="flip-box-front text-center filter-" >
        <div className="inner color-white">
          <h3 className="flip-box-header">1 Éves Hirdetés + Kamionos adatbázis hozzéférés</h3>
          <img src="https://s25.postimg.cc/65hsttv9b/cta-arrow.png" alt="" className="flip-box-img" />
        </div>
      </div>
      <div className="flip-box-back text-center" >
        <div className="inner color-white">
          <p>Egy éven keresztül korlátlanul hirdethet, valamint a rendszerben szereplő kamionosok adatait is folyamatosan böngészheti, hogy mindig kéznél legyen a megfelelő sofőr.</p>
          <button onClick={() => { setSelectedInterest(3); }} className="flip-box-button">Ez érdekel</button>
        </div>
      </div>
    </div>
	</div>
</div>
        </div>

      </>
    );
  
};

export default NewClientRequest;
